/*
 * @Author: etong
 * @Date: 2021-12-27 16:20:17
 * @LastEditTime: 2022-11-30 17:28:21
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\utils\formChangeEvent.js
 * Think first, Program later
 */
import { optionsChain, number_format, deepClone } from '@/utils'
import request from '@/utils/request'
import linkMethods from '@/utils/lowcodeUtil/linkMethods.js' // 低代码公式库

const formItemLinkConfig = {} // 表单元素配置对象
let lowcodeFormConfig = {} // 表单配置项源
let lowcodeFormInstance = {} // 表单实例
let lowcodeFormTableInstance = {} // 表单表格实例
let lowcodeFlag = '' // 默认不传
let lowcodeCurrentRowData = {} // 当前修改行列表数据
let currentFormItem = {} // 当前修改的表单元素
let lowcodeFormValue = {} // 当前表单实例数据
let formRefsInstance = {} // 主表表单ref
let thisInstance = {} // this实例

/**
 * @description: 设置联动关联值
 * @param {*}
 * @param {*} curKey 当前元素的Key
 * @return {*}
 */
const handleSetLinkValue = function(item, curKey, flag) {
  /**
   * type interfaceAcquire - 接口获取
   * type fixValue - 固定值
   * type formula - 公式
   * linkKey 关联key
   */
  const { type, linkKey } = item
  if (type === 'interfaceAcquire') {
    handlelinkValueInterface(item, curKey, flag, type)
  }

  if (type === 'fixValue') {
    handlelinkValueFix(item, curKey, flag)
  }

  if (type === 'formula') {
    handlelinkValueFormula(item, curKey, flag)
  }

  if (type === 'selectSourceData') {
    handlelinkValueInterface(item, curKey, flag, type)
  }

  if (type === 'computeFormula') {
    handlelinkValueComputeFormula(item, curKey, flag)
  }
}

/**
 * @description: 处理接口方式的联动赋值
 * @param setLinkValue {Object} 接口配置数据
 * @param curKey {String} 当前元素key
 * @param type {String} 操作类型
 * @return {*}
 */
const handlelinkValueInterface = function(setLinkValue, curKey, flag, type) {
  let { linkKey, apiMethod, apiUrl, apiParams, cb, key: itemkey, optionsId } = setLinkValue
  const APIPARAMS = Object.assign({}, apiParams)
  /**
   * 主键用curKey 由于可能会有多个地方使用联动的关联key
   * 会导致关联key 不唯一
   */
  if (!(curKey in formItemLinkConfig)) {
    formItemLinkConfig[`${curKey}-${optionsId}`] = {}
  }

  for (const key in apiParams) {
  /**
   * 只记录第一次
   * 之后不做记录
   */
    if (!(key in formItemLinkConfig[`${curKey}-${optionsId}`])) {
      formItemLinkConfig[`${curKey}-${optionsId}`][key] = apiParams[key]
    }
    /**
     * 循环配置参数中的属性，转换配置的参数为真实的值
     */
    convertConfigvalToValue({ source: apiParams, result: APIPARAMS, key, val: formItemLinkConfig[`${curKey}-${optionsId}`][key] })
  }

  const params = {
    url: apiUrl,
    method: apiMethod
  }

  if (!apiMethod || apiMethod === 'get' || apiMethod === 'Get') {
    params['data'] = {}
    params['params'] = APIPARAMS
  } else {
    params['params'] = {}
    params['data'] = APIPARAMS
  }

  request(
    params
  ).then((res) => {
  /**
   * NOTE: 有新情况需要拓展
   * 这里只要判断只要有点 就是有层级结构
   */
    if (linkKey.indexOf('.') < 0) {
    // 如果只有一个单独的key 默认将其挂载到data上去
      linkKey = (flag === 'form' ? 'data.' : 'list[i].') + linkKey
    }

    setLinkKeyValue(linkKey, res, flag, type)
  }).catch((err) => {
    console.log('处理接口方式时报错，原因：', err)
  })
}

/**
 * @description: 处理联动固定值赋值
 * @param linkKey {String} 关联key
 * @param curKey {String} 当前元素key
 * @param res {Object} 返回结果
 * @return {*}
 */
const handlelinkValueFix = function(setLinkValue, curKey, flag) {
  const _this = lowcodeFormInstance
  /**
   * 1、除字符串之外的数字
   * 2、字符串值
   * 3、字符串需要转真实的取值
   */
  let { linkKey, value, type } = setLinkValue
  setLinkValue['valueConfig'] = value

  if (linkKey.indexOf('.') < 0) {
    // 如果只有一个单独的key 默认将其挂载到data上去
    linkKey = (flag === 'form' ? 'data.' : 'list[i].') + linkKey
  }
  const MAIN_KEY = linkKey.split('.')[0] // 主key
  const CHILD_KEY = linkKey.split('.')[1] // 子key
  const fixedValue = getFixLinkValue(setLinkValue, curKey) // 解析后的值或者 传入的固定的值
  if (linkKey.startsWith('data.')) {
    _this[CHILD_KEY] = fixedValue
    // this.$emit('input', { ...this.value, [CHILD_KEY]: fixedValue })
  } else if (linkKey.startsWith('list[i].')) {
    /**
       * 直接修改当前行 这个key 数据
       */
    lowcodeCurrentRowData[CHILD_KEY] = fixedValue
  } else {
    // 主key 子key 需要存在 且值得存在
    // if (MAIN_KEY && CHILD_KEY && _this[MAIN_KEY]) {
    //   lowcodeFormInstance.$set(_this[MAIN_KEY], CHILD_KEY, fixedValue)
    //   if (MAIN_KEY === 'formValue') {
    //     // this.$emit('input', { ...this.value, [CHILD_KEY]: fixedValue })
    //   }
    // }
    if (MAIN_KEY && CHILD_KEY && _this[MAIN_KEY]) {
      if (MAIN_KEY === 'list') {
        for (const dataItem of _this['list']) {
          dataItem[CHILD_KEY] = fixedValue
        }
        // _this.$set(_this['list'], CHILD_KEY, fixedValue)
      } else {
        _this.$set(_this[MAIN_KEY], CHILD_KEY, fixedValue)
      }
    }
  }
}

/**
 * @description: 获取固定值模式下的值
 * @param value {String|Number} 表达式或者字符串 或者数字
 * @param curKey {String} 当前元素的Key
 * @return {*}
 */
const getFixLinkValue = function(setLinkValue, curKey) {
  const { linkKey, value, type, key: itemKey, valueConfig, optionsId } = setLinkValue
  /**
   * 主键用itemkey 由于可能会有多个地方使用联动的关联key
   * 会导致关联key 不唯一
   */
  if (!(curKey in formItemLinkConfig)) {
    formItemLinkConfig[`${curKey}-${optionsId}`] = {}
  }

  if (typeof valueConfig === 'string') {
    const isFixValue = valueConfig.startsWith('$this.') // 判断是否是固定值 有$this的 都是需要特殊处理
    const isFunction = valueConfig.startsWith('get') // 通过get开头的函数方式
    if (!isFunction) {
      if (!isFixValue) {
        return value
      } else {
        const trueValue = eval(optionsChain(value.replace('$this.', '$lowcodeFormInstance.'))) // 从表单实例对象中取到对应的数据值
        return trueValue
      }
    } else {
      const [functionStr, serachParams] = valueConfig.split(')')
      const [functionMethod, params] = functionStr.split('(')
      const formItem = linkMethods[functionMethod](getqutoMarksBetweenStr(params), lowcodeFormConfig)
      if (formItem && Object.keys(formItem).length > 0) {
        console.log('formItem[serachParams]', eval('(' + 'formItem' + serachParams + ')'))
      }
    }
  } else {
    return value
  }
}

/**
 * @description: 获取引号之间的内容
 * @param {*} str
 * @return {*}
 */
const getqutoMarksBetweenStr = function(str) {
  const reg = /["|'](.*)["|']/g
  return str.replace(/\"|\'/g, '')
}

/**
 * @description: 处理联动公式赋值
 * @param {String} curKey
 * @return {*}
 */
const handlelinkValueFormula = function(setLinkValue, curKey, flag) {
  const _this = lowcodeFormInstance
  /**
   * 1、除字符串之外的数字
   * 2、字符串值
   * 3、字符串需要转真实的取值
   * itemKey 当前元素的key 用来做配置唯一主键
   */
  let { linkKey, value, type, params = {}} = setLinkValue

  if (linkKey.indexOf('.') < 0) {
  // 如果只有一个单独的key 默认将其挂载到data上去
    linkKey = (flag === 'form' ? 'data.' : 'list[i].') + linkKey
  }
  const MAIN_KEY = linkKey.split('.')[0] // 主key
  const CHILD_KEY = linkKey.split('.')[1] // 子key
  const computeValue = getComputeValue(setLinkValue, curKey) // 解析公式计算后的值

  if (linkKey.startsWith('data.')) {
    _this[CHILD_KEY] = computeValue
  } else if (linkKey.startsWith('list[i].')) {
    /**
     * 直接修改当前行 这个key 数据
     */
    lowcodeCurrentRowData[CHILD_KEY] = computeValue
  } else {
    // 主key 子key 需要存在 且值得存在
    if (MAIN_KEY && CHILD_KEY && _this[MAIN_KEY]) {
      if (MAIN_KEY === 'list') {
        for (const dataItem of _this['list']) {
          dataItem[CHILD_KEY] = computeValue
        }
      } else {
        lowcodeFormInstance.$set(_this[MAIN_KEY], CHILD_KEY, computeValue)
      }
    }
    lowcodeFormInstance.$set(_this[MAIN_KEY], CHILD_KEY, computeValue)
  }
}

/**
 * @description: 处理联动公式赋值
 * @param {String} curKey
 * @return {*}
 */
const handlelinkValueComputeFormula = function(setLinkValue, curKey, flag) {
  const _this = lowcodeFormInstance
  /**
   * 1、除字符串之外的数字
   * 2、字符串值
   * 3、字符串需要转真实的取值
   * itemKey 当前元素的key 用来做配置唯一主键
   */
  let { linkKey } = setLinkValue

  if (linkKey.indexOf('.') < 0) {
  // 如果只有一个单独的key 默认将其挂载到data上去
    linkKey = (flag === 'form' ? 'data.' : 'list[i].') + linkKey
  }
  const MAIN_KEY = linkKey.split('.')[0] // 主key
  const CHILD_KEY = linkKey.split('.')[1] // 子key
  const computeValue = getComputeFormulaValue(setLinkValue, curKey) // 解析公式计算后的值

  if (linkKey.startsWith('data.')) {
    _this[CHILD_KEY] = computeValue
  } else if (linkKey.startsWith('list[i].')) {
    /**
     * 直接修改当前行 这个key 数据
     */
    lowcodeCurrentRowData[CHILD_KEY] = computeValue
  } else {
    // 主key 子key 需要存在 且值得存在
    if (MAIN_KEY && CHILD_KEY && _this[MAIN_KEY]) {
      if (MAIN_KEY === 'list') {
        for (const dataItem of _this['list']) {
          dataItem[CHILD_KEY] = computeValue
        }
      } else {
        lowcodeFormInstance.$set(_this[MAIN_KEY], CHILD_KEY, computeValue)
      }
    }
    lowcodeFormInstance.$set(_this[MAIN_KEY], CHILD_KEY, computeValue)
  }
}

/**
 * [number_format 参数说明：]
 * @param  {[type]} number        [number：要格式化的数字]
 * @param  {[type]} decimals      [decimals：保留几位小数,默认2]
 * @param  {[type]} dec_point     [dec_point：小数点符号]
 * @param  {[type]} thousands_sep [thousands_sep：千分位符号]
 * @param  {[type]} roundtag      [roundtag:舍入参数，默认"round" 四舍五入, "ceil" 向上取,"floor"向下取]
 * @return {[type]}               [description]
 *
 */
const setNumberFormat = function(num, formatOptions) {
  if (formatOptions && Object.keys(formatOptions).length > 0) {
    const { decimals, dec_point, thousands_sep, roundtag } = formatOptions
    return number_format(num, decimals, dec_point, thousands_sep, roundtag)
  } else {
    return num
  }
}

/**
 * @description: 解析公式计算后的值
 * @param {*}
 * @param curKey {String} 当前元素key
 * @return {*}
 */
const getComputeValue = function(setLinkValue, curKey) {
  const { linkKey, calculateMethod, params = {}, key: itemKey } = setLinkValue
  const cpParams = Object.assign({}, params)
  // 将values解析转换
  cpParams['values'] = complieConfigValues(cpParams['values'], calculateMethod)
  const value = eval(linkMethods[calculateMethod](cpParams))
  return setNumberFormat(value, (cpParams['formatOptions'] || {}))
}

/**
 * @description: 解析公式计算后的值
 * @param {*}
 * @param curKey {String} 当前元素key
 * @return {*}
 */
const getComputeFormulaValue = function(setLinkValue, curKey) {
  const { value } = setLinkValue
  // 将values解析转换
  console.log('value', value)
  console.log(value.replace(/this./g, 'lowcodeFormInstance.'))
  console.log('cpParams', eval(value.replace(/this./g, 'lowcodeFormInstance.')))
  const computeValue = eval(value.replace(/this./g, 'lowcodeFormInstance.'))
  return computeValue
}

/**
 * @description: 处理表单元素联动
 * @param {*}
 * @return {*}
 */
export function handleLinkChangeEvent(options) {
  /**
   * flag 标记 table - 表格
   * flag 标记 form - 主表
   */
  const { val, item, formTableInstance, formInstance, flag, currentRowData = {}, formConfig = {}, thisCp, formRefs } = options
  const { key, type, rules } = item
  lowcodeFormInstance = thisCp.lowcodeFormInstance
  lowcodeFormTableInstance = formTableInstance
  lowcodeFlag = flag
  lowcodeCurrentRowData = currentRowData
  currentFormItem = item
  lowcodeFormConfig = formConfig
  lowcodeFormValue = thisCp.value
  formRefsInstance = formRefs
  thisInstance = thisCp

  if (lowcodeFlag === 'form') {
    const _this = lowcodeFormInstance
    const { keyName } = item
    if (type === 'select' && keyName) {
      const keyNameValue = key + '_keyNameValue'
      _this && _this.$emit('input', { ..._this.value, [keyName]: item[keyNameValue], [key]: val })
    } else {
      _this && _this.$emit('input', { ..._this.value, [key]: type === 'input' ? val.trim() : val })
    }
  }

  if (rules && rules.length > 0) {
    // 主表表单元素单个进行当前元素的验证
    formRefsInstance && formRefsInstance.validateField(key)
  }
  // valueLink 值关联操作
  if (item['valueLink'] && item['valueLink'].length > 0) {
    linkValueCbHandler(options)
  }
}

/**
 * @description: 转换对象配置的参数值到真实的值
 * @param source {Object} 参数数据源
 * @param key {string} 数据源中修改的Key
 * @param val {string|number} 数据源中修改的val
 * @return {*}
 */
const convertConfigvalToValue = function(configVal) {
  const { source, result, key, val } = configVal
  if (typeof val === 'string') {
    const isFixValue = val.startsWith('$this.') // 判断是否是固定值 有$this的 都是需要特殊处理
    if (!isFixValue) {
      result[key] = val // 数值string类型,固定值
    } else {
      const trueValue = eval(optionsChain(val.replace('$this.', '$lowcodeFormInstance.'))) // 从表单实例对象中取到对应的数据值
      result[key] = trueValue
    }
  } else {
    result[key] = val // 数值number类型
  }
}

/**
 * @description: 解析配置的values
 * 加法 values[0]+values[1]
 * 减法 values[0]-values[1]
 * 乘法 values[0]*values[1]
 * 除法 values[0]/values[1]
 * 如果 values中 values[0]为$this.list 证明是明细数据
 * @param {Array} values 数据源
 * @return {*}
 */
const complieConfigValues = function(values = [], calculateMethod) {
  let dataSets = []
  let placeNum = 0 // 数字占位符
  for (const val of values) {
    if (typeof val === 'number') {
      dataSets.push(Number(val)) // 数值number类型
    } else {
      if (!val) {
        /**
         * 加减遇到null undefined '' 赋值0
         * 乘除赋值1
         */
        if (calculateMethod === 'lowcodeAdd' || calculateMethod === 'lowcodeSubtract') {
          placeNum = 0
          dataSets.push(0)
        } else {
          placeNum = 1
          dataSets.push(1)
        }
      } else {
        // 在这里判断是明细数据汇总还是简单数据
        if (val.indexOf('$this.list') >= 0) {
          const valSplit = val.split('.')
          const key = valSplit[valSplit.length - 1]
          // 取到列表真实的数据
          const trueList = lowcodeFormInstance.list || []
          // 将取到key那一列值对应赋给 dataSets
          dataSets = [...dataSets, ...(trueList.map((item, index) => {
            if (index === 0 && !(key && key in item && item[key])) {
              console.error('配置的字段:' + key + '不在列表中')
            }
            if (!item[key]) {
              if (calculateMethod === 'lowcodeAdd' || calculateMethod === 'lowcodeSubtract') {
                return 0
              } else {
                return 1
              }
            } else {
              return (key && key in item && Number(item[key]))
            }
          }))]
        } else {
          if (typeof val === 'string') {
            const isFixValue = val.startsWith('$this.') // 判断是否是固定值 有$this的 都是需要特殊处理
            if (!isFixValue) {
              dataSets.push(Number(val)) // 数值string类型,固定值
            } else {
              // 从表单实例对象中取到对应的数据值
              const trueValue = eval(optionsChain(val.replace('$this.', '$lowcodeFormInstance.')))
              dataSets.push(Number(trueValue))
            }
          } else {
            if (val === undefined) {
              dataSets.push(0) // undefined
            } else {
              dataSets.push(Number(val)) // 数值number类型
            }
          }
        }
      }
    }
  }
  return dataSets || []
}

/**
 * @description: 关联key赋值
 * @param linkKey {String} 关联key
 * @param res {Object} 返回结果
 * @param type {string} 当前操作类型
 * @return {*}
 */
const setLinkKeyValue = function(linkKey, res, flag, type) {
  const _this = lowcodeFormInstance
  if (res) {
    let result
    const RESCONTENT = res.data.res_content
    if (typeof RESCONTENT === 'object') {
      /**
       * 1、取data
       * 2、取data_list
       * 3、直接将结果返回
       * 4、判空
       */
      result = RESCONTENT['data'] || RESCONTENT['data_list'] || RESCONTENT || []
    } else {
      result = RESCONTENT // 后端直接返回值 String | Number | Boolean
    }
    const MAIN_KEY = linkKey.split('.')[0]
    const CHILD_KEY = linkKey.split('.')[1]
    if (linkKey.startsWith('data.')) {
      _this[CHILD_KEY] = null
      _this[CHILD_KEY] = result
    } else if (linkKey.startsWith('list[i].')) {
      lowcodeCurrentRowData[CHILD_KEY] = null
      /**
       * 直接修改当前行 这个key 数据
       */
      lowcodeCurrentRowData[CHILD_KEY] = result
    } else {
      const formItem = lowcodeFormConfig['formItemList'] && lowcodeFormConfig['formItemList'].length > 0 &&
      lowcodeFormConfig['formItemList'].filter(item => item.key === CHILD_KEY)[0]
      const { type, key, keyName } = formItem
      if (key) {
        if (type === 'select') {
          _this.$set(_this['formValue'], key, null)
          _this.$set(_this['formValue'], keyName, null)
        }
      }
      // 设置下拉数据源类型
      // 或者是被联动元素是下拉框 数据源赋值
      if (type === 'selectSourceData' || (linkKey.startsWith('formValue.') && type === 'select')) {
        setSelectSourceData(formItem, result)
        return
      }
      // 设置值类型
      if (MAIN_KEY && CHILD_KEY && _this[MAIN_KEY]) {
        if (MAIN_KEY === 'list') {
          for (const dataItem of _this['list']) {
            dataItem[CHILD_KEY] = result
          }
        } else {
          _this.$set(_this[MAIN_KEY], CHILD_KEY, null)
          _this.$set(_this[MAIN_KEY], CHILD_KEY, result)
        }
      }
    }
  }
}

/**
 * @description: 关联元素设置操作回调 隐藏 禁用 必填等
 * @param {*}
 * @return {*}
 */
const linkValueCbHandler = function(options) {
  opCompileHandler(options)
}

/**
 * @description: 规则解析
 * @param {*} options
 * @return {*}
 */
const opCompileHandler = function(options) {
  const _this = lowcodeFormInstance
  /**
   * flag 标记 table - 表格
   * flag 标记 form - 主表
   */
  const { item = {}, flag } = options
  const { valueLink = [] } = item
  for (const opItem of valueLink) {
    // 对valueLink进行循环处理
    const isPass = opValueCompile(opItem) || false

    const { linkList = [], trigger } = opItem
    for (const linkItem of linkList) {
      /**
       * 解析正确的key
       * formdata 主表中的元素
       */
      const { linkKey, operationList = [] } = linkItem
      if (!linkKey) {
        return
      }
      const CHILD_KEY = linkKey.split('.')[1] // formdata 表单数据 Note: 这里不做来源（表单、data）区分 只是取出子属性名
      const formItem = lowcodeFormConfig['formItemList'] && lowcodeFormConfig['formItemList'].length > 0 &&
      lowcodeFormConfig['formItemList'].filter(item => item.key === CHILD_KEY)[0]

      if (linkKey.startsWith('formValue.')) {
        for (const [index, operationItem] of operationList.entries()) {
          const { type, options = {}} = operationItem
          // 用来标记不同的配置项
          options['optionsId'] = `op${index}`
          // 设置值 如果是change事件直接执行 如果是公式 满足公式才可以执行 用三目运算会导致理解起来不清晰
          if (type === 'setLinkValue') {
            /**
             * 由于原有逻辑已处理 目前是对数据结构进行整合 考虑过如果新传入变量
             * 可能需要新增大量代码 不如往当前元素options直接插入一条属性 可能会牺牲一点点空间
             * 但是时间效率相较于传入变量方式有所提升 不算冗余代码
             */
            options['linkKey'] = linkKey
            if (trigger === 'formula') {
              isPass && handleSetLinkValue(options, item.key, flag)
            } else {
              handleSetLinkValue(options, item.key, flag)
            }
            // 如果是公式方式 就判断 如果是change 就默认true
            // setItemValue({ operationItem, CHILD_KEY, isPass: trigger === 'formula' ? isPass : true, isForm: true })
          }
          // 如果联动禁用/取消禁用，则更新禁用
          if (type === 'setDisable' && operationItem['setlinkDisable']) {
            if (trigger === 'formula') {
              setItemDisabled(formItem, isPass)
            } else {
              // setItemChangeDisabled(formItem, isPass) change事件 预留方法 暂不删除
            }
          }
          // 如果联动必填/非必填，则更新
          if (type === 'setRules') {
            const { rules } = operationItem
            if (trigger === 'formula' && rules) {
            // setItemRequired(formItem, isPass)
              isPass && setItemRules(formItem, rules)
            }
            // else {
            // setItemChangeRequired(formItem, isPass) change事件 预留方法 暂不删除
            // }
          }

          // 如果联动隐藏/显示，则更新
          if (type === 'setHidden' && 'setlinkHidden' in operationItem) {
            if (trigger === 'formula') {
              // setItemHidden(formItem, isPass)
              // setlinkHidden 从外部传入进来 不再以是否满足条件 来处理
              isPass && setItemHidden(formItem, isPass, operationItem['setlinkHidden'])
            } else {
              // setItemChangeHidden(formItem, isPass) change事件 预留方法 暂不删除
            }
          }
        }
      } else if (linkKey.startsWith('data.')) {
        // 以data开头的属性名 统一只有赋值操作 没有隐藏显示操作
        for (const operationItem of operationList) {
          const { type, trigger, options } = operationItem
          // 设置值 如果是change事件直接执行 如果是公式 满足公式才可以执行 用三目运算会导致理解起来不清晰
          if (type === 'setLinkValue') {
            /**
             * 由于原有逻辑已处理 目前是对数据结构进行整合 考虑过如果新传入变量
             * 可能需要新增大量代码 不如往当前元素options直接插入一条属性 可能会牺牲一点点空间
             * 但是时间效率相较于传入变量方式有所提升 不算冗余代码
             */
            options['linkKey'] = linkKey
            if (trigger === 'formula') {
              isPass && handleSetLinkValue(options, item.key, flag)
            } else {
              handleSetLinkValue(options, item.key, flag)
            }
          }
        }
      }
      _this.$forceUpdate()
    }
  }
}

/**
 * @description: 找到顶级元素 也就是当前页面的实例
 * @param {*} instance
 * @param {*} key
 * @return {*}
 */
const getParentKey = function(instance, key) {
  let component = instance
  if (component && component.$parent && !(key in component.$parent)) {
    return
  } else {
    component = instance && instance.$parent
    getParentKey(component, key)
  }
  return component
}

/**
 * @description: 设置表单元素必填
 * @param {*}
 * @return {*}
 */
const setItemRequired = function(item, bol) {
  const _this = lowcodeFormInstance
  if (bol) {
    if (!('rules' in item)) {
      _this.$set(item, 'rules', [{
        'required': true,
        'message': '此项为必填项',
        'trigger': ['blur', 'change']
      }])
    } else {
      item['rules'].push({
        'required': true,
        'message': '此项为必填项',
        'trigger': ['blur', 'change']
      })
    }
  } else {
    const { rules, key } = item
    if (!rules || rules.length == 0) {
      return
    } else {
      const filterArr = rules.filter(el => !el.required)
      _this.$set(item, 'rules', filterArr)
    }
    formRefsInstance && formRefsInstance.clearValidate([key])
  }
}

/**
 * @description: 对表单元素设置规则 NOTE：可以支持必填等
 * @param {*} item
 * @param {*} rules
 * @return {*}
 */
const setItemRules = function(item, rules) {
  const { key } = item
  // const ruleArr = []
  // if (rules && rules.length > 0) {
  //   rules.forEach(rule => {
  //     ruleArr.push(rule)
  //   })
  // }
  thisInstance.$nextTick(function() {
    item['rules'] = rules
    thisInstance.$set(thisInstance, 'formConfig', lowcodeFormConfig)
  })
  formRefsInstance && formRefsInstance.clearValidate([key])
}

/**
 * @description: 设置表单元素禁用
 * @param {*}
 * @return {*}
 */
const setItemDisabled = function(item, bol) {
  const _this = lowcodeFormInstance
  _this.$set(item, 'disabled', bol)
}

/**
 * @description: 设置表单元素隐藏
 * @param {*}
 * @return {*}
 */
const setItemHidden = function(item, isPass, bol) {
  thisInstance.$nextTick(function() {
    item['isShow'] = !bol
    thisInstance.$set(thisInstance, 'formConfig', lowcodeFormConfig)
  })
}

/**
 * @description: 设置值
 * @param {*} item
 * @param {*} value
 * @return {*}
 */
const setItemValue = function(options) {
  const { operationItem, CHILD_KEY, isPass, isForm, isData } = options
  const _this = lowcodeFormInstance
  if ('linkValue' in operationItem) {
    const { linkValue } = operationItem
    // 如果非表单元素 我们就设置值
    const setLinkValue = {}
    const curKey = CHILD_KEY
    setLinkValue['value'] = linkValue
    setLinkValue['valueConfig'] = linkValue
    if (isPass) {
      const fixedValue = getFixLinkValue(setLinkValue, curKey) // 解析后的值或者 传入的固定的值
      if (!isForm) {
        const instance = getParentKey(_this, CHILD_KEY)
        instance[CHILD_KEY] = fixedValue
      } else {
        _this.$set(_this.value, CHILD_KEY, fixedValue)
      }
    }
  }
}

/**
 * @description: 设置下拉数据源
 * @param {string} item 元素
 * @param {string|Array} res 返回结果
 * @return {*}
 */
const setSelectSourceData = function(item, res) {
  const _this = lowcodeFormInstance
  item['options'] = []
  _this.$set(item, 'options', res)
}

/**
 * @description:  重置关联元素值
 * @return {*}
 */
const resetLinkItemValue = function(linkKey) {

}

/**
 * @description: 操作规则的具体解析
 * @param {*} valueLen 字符长度
 * @return {*}
 */
const opValueCompile = function(opItem) {
  const { value, op, linkList } = opItem
  const valueLen = value ? ((value + '').indexOf(',') >= 0 ? ((value + '').split(',').length) : 1) : 0
  const valueCp = valueLen > 1 ? (value + '').split(',') : [value]
  const computeValue = valueLen > 1 ? complieConfigValues(valueCp, '').join(',') : valueCp
  console.log('computeValue', computeValue)
  const curKey = currentFormItem['key']
  const curValue = lowcodeFormValue[curKey]
  // 1、value 为单个值 > >= < <= = !=
  // 2、value 为两个值 [] () (] [) 需要特殊处理 日期和数值
  // 3、value 为多个值 = 或 != 且
  const handleObj = {
    0: function() {
      return 0
    }, //
    1: function() {
      let isTrue
      switch (op) {
        case '>':
        {
          isTrue = Number(curValue || 0) > Number(computeValue)
          break
        }
        case '>=':
        {
          isTrue = Number(curValue || 0) >= Number(computeValue)
          break
        }
        case '<':
        {
          isTrue = Number(curValue || 0) < Number(computeValue)
          break
        }
        case '<=':
        {
          isTrue = Number(curValue || 0) <= Number(computeValue)
          break
        }
        case '=':
        {
          isTrue = (curValue || '') == (computeValue)
          break
        }
        case '!=':
        {
          isTrue = (curValue || '') != (computeValue)
          break
        }
        default:
          break
      }
      return isTrue
    }, //
    2: function() {
      const [first, last] = computeValue.split(',')
      let isTrue
      switch (op) {
        case '[]':
        {
          isTrue = Number(curValue || 0) >= first && Number(curValue || 0) <= last
          break
        }
        case '()':
        {
          isTrue = Number(curValue || 0) > first && Number(curValue || 0) < last
          break
        }
        case '(]':
        {
          isTrue = Number(curValue || 0) > first && Number(curValue || 0) <= last
          break
        }
        case '[)':
        {
          isTrue = Number(curValue || 0) >= first && Number(curValue || 0) < last
          break
        }
        default:
          break
      }
      return isTrue
    }, //
    'more': function() {
      let isMoreTrue
      switch (op) {
        case '=':
        {
          isMoreTrue = false

          for (const item of computeValue.split(',')) {
            isMoreTrue = (isMoreTrue || curValue == item)
          }
          break
        }
        case '!=':
        {
          isMoreTrue = true

          for (const item of computeValue.split(',')) {
            isMoreTrue = (isMoreTrue && curValue != item)
          }
          break
        }
        default:
          break
      }
      return isMoreTrue
    } //
  }
  return handleObj[valueLen > 2 ? 'more' : valueLen]()
}
